import React from "react";
import { Provider } from "react-redux";
import { MemoryRouter } from "react-router-dom";
import Security from "../components/views/Security";
import { securityState } from "./sampleData";

/**
 * Component preview harness (dev only). Renders a real page component through the real
 * webpack/SCSS pipeline with a static mock store + sample data - no backend, no auth, hot
 * reloads on edit. Selected by `REACT_APP_PREVIEW=<name>` in index.js.
 *
 *   PORT=3010 REACT_APP_PREVIEW=security BROWSER=none npm start
 *
 * The store is static: reads return the sample state and dispatch swallows thunks/actions
 * (no reducers run), so on-mount fetches are no-ops. Local component state (staging edits,
 * the status bar, input gating) works normally.
 */
const PREVIEWS = {
    security: { Component: Security, state: securityState },
};

export function mountPreview(root, name) {
    const preview = PREVIEWS[name];
    if (!preview) {
        root.render(
            <div style={{ padding: 24, color: "#fff", fontFamily: "sans-serif" }}>
                Unknown preview &quot;{name}&quot;. Available: {Object.keys(PREVIEWS).join(", ")}
            </div>
        );
        return;
    }
    const Comp = preview.Component;
    const store = {
        getState: () => preview.state,
        subscribe: () => () => {},
        dispatch: (action) => (typeof action === "function" ? undefined : action),
    };
    root.render(
        <Provider store={store}>
            <MemoryRouter>
                <div style={{ background: "#2e3332", minHeight: "100vh" }}>
                    <Comp />
                </div>
            </MemoryRouter>
        </Provider>
    );
}
